module.exports = __webpack_public_path__ + "static/hero-profile-30fdae00b983eacb673b44b19af3151b.jpg";